import { render, staticRenderFns } from "./GroupsContainer.vue?vue&type=template&id=215b02f1&scoped=true"
import script from "./GroupsContainer.vue?vue&type=script&lang=js"
export * from "./GroupsContainer.vue?vue&type=script&lang=js"
import style0 from "./GroupsContainer.vue?vue&type=style&index=0&id=215b02f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b02f1",
  null
  
)

export default component.exports